import React, { useEffect, useState } from "react";
import { Button, Form, Input, message } from "antd";
import sanitizeHtml from "sanitize-html";
import ReactHtmlParser from "react-html-parser";
import { Link, useHistory } from "react-router-dom";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { validatePassword } from "../../../constants/Validation";
import ForgotPasswordAPI from "../../../services/ForgotPassword/ForgotPassword";
import { getCookie } from "../../../helpers/Cookie";

const forgotPasswordApi = new ForgotPasswordAPI();

const ForgotPassword = () => {
  const history = useHistory();
  const [isSubmitBtnLoading, setIsSubmitBtnLoading] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [forgotPasswrodStep, setForgotPasswordStep] = useState(1);

  useEffect(() => {
    const token = getCookie("token");
    if (token) {
      history.push("/dashboard/crm");
    }

    //eslint-disable-next-line
  }, []);

  // forgot password send request
  const onForgotRequestFinish = async (fieldValues) => {
    try {
      setIsSubmitBtnLoading(true);
      let tempUserEmail = sanitizeHtml(fieldValues["email"]);

      if (tempUserEmail !== "") {
        const payload = {
          email: tempUserEmail,
        };
        const response = await forgotPasswordApi.forgotPasswordRequest(
          JSON.stringify(payload).replace(/</g, "\\u003c"),
        );
        if (response && response.data) {
          if (response.data.isSend) {
            message.success(
              "Verification code has been sent to your registered email id successfully.",
            );
            // message.success(response.data.message);
            // history.push('/login');
            setUserEmail(tempUserEmail);
            setForgotPasswordStep(2);
          } else {
            if (response.data.message) {
              message.error(response.data.message);
            } else {
              message.error("Something went wrong! Please try again later.");
            }
          }
        } else {
          message.error("Something went wrong! Please try again later.");
        }
      } else {
        message.error("Invalid data. Please put valid data in the fields.");
      }
    } catch (e) {
      message.error("Something went wrong! Please try again later.");
    } finally {
      setIsSubmitBtnLoading(false);
    }
  };

  // resend verification code
  const resendCode = async () => {
    try {
      const payload = {
        email: userEmail,
      };

      const response = await forgotPasswordApi.forgotPasswordRequest(
        JSON.stringify(payload).replace(/</g, "\\u003c"),
      );
      if (response && response.data) {
        if (response.data.isSend) {
          message.success(response.data.message);
        } else {
          if (response.data.message) {
            message.error(response.data.message);
          } else {
            message.error("Something went wrong! Please try again later.");
          }
        }
      } else {
        message.error("Something went wrong! Please try again later.");
      }
    } catch (error) {
      message.error("Something went wrong! Please try again later.");
    }
  };

  // forgot password update password with code
  const onResetPasswrod = async (fieldValues) => {
    try {
      setIsSubmitBtnLoading(true);

      let tempNewPass = ReactHtmlParser(
        sanitizeHtml(fieldValues["new-password"]),
      );
      let tempConfirmPass = ReactHtmlParser(
        sanitizeHtml(fieldValues["confirm-password"]),
      );
      let tempVerificationCode = ReactHtmlParser(
        sanitizeHtml(fieldValues["verification-code"]),
      );

      if (
        tempNewPass[0] !== "" &&
        tempConfirmPass[0] !== "" &&
        tempVerificationCode[0] !== ""
      ) {
        const payload = {
          email: userEmail,
          newPassword: tempNewPass[0],
          newConfirmPassword: tempConfirmPass[0],
          code: tempVerificationCode[0],
        };
        const response = await forgotPasswordApi.verifyForgotPasswordCode(
          JSON.stringify(payload).replace(/</g, "\\u003c"),
        );
        if (response && response.data) {
          if (response.data.isUpdate) {
            message.success("Your password has been updated successfully.");
            // message.success(response.data.message);
            console.log("response.data.message", response.data.message);
            history.push("/login");
            setForgotPasswordStep(1);
            setUserEmail("");
          } else {
            if (response.data.message) {
              message.error("Invalid verification code.");
              // message.error(response.data.message);
            } else {
              message.error("Something went wrong! Please try again later.");
            }
          }
        } else {
          message.error("Something went wrong! Please try again later.");
        }
      } else {
        message.error("Invalid data. Please put valid data in the fields.");
      }
    } catch (e) {
      message.error("Something went wrong! Please try again later.");
    } finally {
      setIsSubmitBtnLoading(false);
    }
  };

  // validate space key
  const validateSpaceLey = (values) => {
    // avoid space
    if (values.keyCode === 32) {
      values.preventDefault();
    }
  };

  const trimSpaces = (value) => value.trim();

  return (
    <div className="gx-app-login-wrap">
      <div className="gx-login-container">
        <div className="gx-login-content forgot-password-content">
          <div className="gx-login-header gx-text-center">
            <h1 className="gx-login-title">
              {forgotPasswrodStep === 1
                ? "Forgot Password?"
                : "Set New Password"}
            </h1>
          </div>
          <div className="gx-mb-4">
            <p>
              {forgotPasswrodStep === 1
                ? "Enter your email address and we'll send you a verification code to set your password."
                : "Enter verification code to set your password."}
            </p>
          </div>

          {/* forgot password send request form */}
          {forgotPasswrodStep === 1 ? (
            <Form
              initialValues={{ remember: true }}
              name="forgot-password-request"
              onFinish={onForgotRequestFinish}
              className="gx-signin-form gx-form-row0"
            >
              <Form.Item
                rules={[
                  {
                    type: "email",
                    message: (
                      <span className="custom-error-message">
                        Please enter valid email address.
                      </span>
                    ),
                  },
                  {
                    required: true,
                    whitespace: true,
                    message: (
                      <span className="custom-error-message">
                        Please enter email address.
                      </span>
                    ),
                  },
                ]}
                hasFeedback
                name="email"
                normalize={trimSpaces}
              >
                <Input prefix={<UserOutlined />} placeholder="Enter email" />
              </Form.Item>

              <Form.Item className="signin-bottom-links">
                <Button
                  type="primary"
                  className="gx-mb-0"
                  htmlType="submit"
                  loading={isSubmitBtnLoading}
                >
                  Send
                </Button>
                <Link to="/login">Login</Link>
              </Form.Item>
            </Form>
          ) : (
            /* forgot password update password with code */
            <Form
              initialValues={{ remember: true }}
              name="reset-password"
              onFinish={onResetPasswrod}
              className="gx-signin-form gx-form-row0"
            >
              <Form.Item
                style={{ marginBottom: "32px" }}
                rules={[
                  {
                    required: true,
                    whitespace: true,
                    message: (
                      <span className="custom-error-message">
                        Please enter verification code.
                      </span>
                    ),
                  },
                ]}
                hasFeedback
                name="verification-code"
              >
                <Input placeholder="Verification code" />
              </Form.Item>
              <span
                className="resend-code-link link-underline"
                onClick={() => resendCode()}
              >
                <Link to="#">Resend Code?</Link>
              </span>

              <Form.Item
                style={{ marginBottom: "32px" }}
                rules={[
                  {
                    required: true,
                    whitespace: true,
                    message: (
                      <span className="custom-error-message">
                        Please enter new password.
                      </span>
                    ),
                  },
                  {
                    validator: validatePassword,
                  },
                ]}
                hasFeedback
                name="new-password"
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  type="password"
                  placeholder="New password"
                  onKeyDown={(e) => validateSpaceLey(e)}
                />
              </Form.Item>
              <Form.Item
                style={{ marginBottom: "32px" }}
                rules={[
                  {
                    required: true,
                    whitespace: true,
                    message: (
                      <span className="custom-error-message">
                        Please enter confirm password.
                      </span>
                    ),
                  },
                  ({ getFieldValue }) => ({
                    validator(rule, value) {
                      if (!value || getFieldValue("new-password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        <span className="custom-error-message">
                          New password and confirm new password field do not
                          match. Match them up to move on with life.
                        </span>,
                      );
                    },
                  }),
                ]}
                hasFeedback
                name="confirm-password"
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  type="password"
                  placeholder="Confirm password"
                  onKeyDown={(e) => validateSpaceLey(e)}
                />
              </Form.Item>

              <Form.Item className="signin-bottom-links">
                <Button
                  type="primary"
                  className="gx-mb-0"
                  htmlType="submit"
                  loading={isSubmitBtnLoading}
                >
                  Update
                </Button>
                <Link to="#" onClick={() => setForgotPasswordStep(1)}>
                  Cancel
                </Link>
              </Form.Item>
            </Form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
